// Enable or Disable the GDPR popup in Theme Settings.
// If the customer accepts marketing, GTM will be enabled.

// If you're not using Shopify Plus, you'll have to manually update the
// Additional Checkout Scripts. Use the checkout.liquid file for reference.

// Apps will have to be curated separately.

export default class GdprPopup {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.state = {
        $popup: $('.js-gdpr-popup'),
        version: $('.js-gdpr-version').val()
      };

      this.checkForConsent();
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Checks if the user has already given consent. If not, show popup.
  //===========================================================================

  checkForConsent() {
    if (this.state.$popup[0] && !this.generalConsentStatus()) {
      this.state.$popup.removeClass('hidden');
    }
  }

  //===========================================================================
  // Applies the user's consent to the browser
  //===========================================================================

  applyConsent() {
    const acceptsMarketing = this.state.$popup.find('.js-gdpr-marketing-checkbox').is(':checked');

    this.addConsentCookies(acceptsMarketing);
    this.state.$popup.addClass('hidden');
  }

  //===========================================================================
  // Checks if the popup has been interacted with
  //===========================================================================

  generalConsentStatus() {
    const cookies = document.cookie.replace(/\s/g, '').split(';');
    let status = false;

    cookies.forEach((cookie) => {
      if (cookie.includes(`ccm_accepted_v_${ this.state.version }`)) {
        status = true;
      }
    });

    return status;
  }

  //===========================================================================
  // Checks if the customer has given marketing consent
  //===========================================================================

  marketingConsentStatus() {
    const cookies = document.cookie.replace(/\s/g, '').split(';');
    let status = false;

    cookies.forEach((cookie) => {
      if (cookie.includes(`ccm_accepted_marketing_v_${ this.state.version }`)) {
        status = true;
      }
    });

    return status;
  }

  //===========================================================================
  // Adds consent cookies
  //===========================================================================

  addConsentCookies(acceptsMarketing) {
    document.cookie = `ccm_accepted_v_${ this.state.version }=true; path=/`;

    if (acceptsMarketing) {
      document.cookie = `ccm_accepted_marketing_v_${ this.state.version }=true; path=/`;
    }
  }

  //===========================================================================
  // Removes consent cookies
  //===========================================================================

  removeConsentCookies() {
    const cookies = document.cookie.replace(/\s/g, '').split(';');

    cookies.forEach((cookie) => {
      if (cookie.includes('ccm_accepted')) {
        let cookieName = cookie.split('=')[0];
        document.cookie = `${ cookieName }= ; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
      }
    });
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-gdpr-button', this.applyConsent.bind(this));
  }
}
